/**
 * Created by mateimisarca on 24/11/2019
 */

import choice from './choice';

export default choice;
